// extracted by mini-css-extract-plugin
export var button = "BurgerBtn-module--button--c0b43";
export var active = "BurgerBtn-module--active--d2975";
export var wrapper = "BurgerBtn-module--wrapper--b47b1";
export var fixed = "BurgerBtn-module--fixed--8ebf3";